<template>
  <div :class="addressSelectPage.domClass || ''">
    <!-- 选择省 -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(1)"
      :disabled="idDisabled(1)" clearable :size="sizeRule()" @change="provincesChange" v-model="addresObj.provinces"
      placeholder="选择省">
      <el-option v-for="item in provincesList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
    <!-- 选择市 -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(2)"
      :disabled="idDisabled(2)" clearable @change="citiesChange" :size="sizeRule()" v-model="addresObj.cities"
      placeholder="选择市" no-data-text="请先选择省">
      <el-option v-for="item in citiesList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
    <!-- 选择县 -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(3)"
      :disabled="idDisabled(3)" clearable @change="areasChange" :size="sizeRule()" v-model="addresObj.areas"
      placeholder="选择县区" no-data-text="请先选择市">
      <el-option v-for="item in areasList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
    <!-- 选择乡镇（街道） -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(4)"
      :disabled="idDisabled(4)" clearable @change="streetsChange" :size="sizeRule()" v-model="addresObj.streets"
      placeholder="选择乡镇（街道）" no-data-text="请先选择县区">
      <el-option v-for="item in streetsList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
    <!-- 选择村 -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(5)"
      :disabled="idDisabled(5)" clearable @change="villageChange" :size="sizeRule()" v-model="addresObj.village"
      placeholder="选择村（居委会）" no-data-text="请先选择乡镇（街道）">
      <el-option v-for="item in villageList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
    <!-- 选择组 -->
    <el-select filterable :popper-append-to-body="false" :style="selectClassFn()" v-if="isShowFn(6)"
      :disabled="idDisabled(6)" clearable @change="zuChange" :size="sizeRule()" v-model="addresObj.zu" placeholder="选择组"
      no-data-text="请先选择村（居委会）">
      <el-option v-for="item in zuList" :key="item.code" :label="item.name" :value="item.code">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { villagesPage, zuPage } from '@/api/api.js'
export default {
  props: ['addressSelectPage', 'isAuto'],
  data() {
    return {
      keyList: ['provinces', 'cities', 'areas', 'streets', 'village', 'zu'],
      dataArrList: ['provincesList', 'citiesList', 'areasList', 'streetsList', 'villageList', 'zuList'],
      addressCode: [],
      addressText: [],
      // provincesList: this.$common.getprovinces(),
      provincesList: [],
      citiesList: [],
      areasList: [],
      streetsList: [],
      villageList: [],
      zuList: [],
      addresObj: {
        provinces: '',
        cities: '',
        areas: '',
        streets: '',
        village: '',
        zu: ''
      }
    }
  },
  computed: {
  },
  methods: {
    // 样式
    selectClassFn(type) {
      let str = 'width:160px;margin-right:5px;'
      if (this.addressSelectPage.style) {
        return str + this.addressSelectPage.style
      }
      return str
    },
    // 省change
    provincesChange(e) {
      if (e) {
        if (this.isShowFn(2)) {
          this.getVillage(e, 'citiesList')
        }
        // this.citiesList = this.$common.getcities(e)
        this.addressCode[0] = e
        this.provincesList.forEach(item => {
          if (item.code === e) {
            this.addressText[0] = item.name
          }
        })
        this.empty(0, true)
      } else {
        this.empty(0, false)
      }
    },
    // 市change
    citiesChange(e) {
      if (e) {
        if (this.isShowFn(3)) {
          this.getVillage(e, 'areasList')
        }
        // this.areasList = this.$common.getareas(e)
        this.addressCode[1] = e
        this.citiesList.forEach(item => {
          if (item.code === e) {
            this.addressText[1] = item.name
          }
        })
        this.empty(1, true)
      } else {
        this.empty(1, false)
      }
    },
    // 县change
    areasChange(e) {
      if (e) {
        if (this.isShowFn(4)) {
          this.getVillage(e, 'streetsList')
        }
        // this.streetsList = this.$common.getstreets(e)
        this.addressCode[2] = e
        this.areasList.forEach(item => {
          if (item.code === e) {
            this.addressText[2] = item.name
          }
        })
        this.empty(2, true)
      } else {
        this.empty(2, false)
      }
    },
    // 乡镇、街道change
    streetsChange(e) {
      if (e) {
        if (this.isShowFn(5)) {
          this.getVillage(e, 'villageList')
        }

        this.addressCode[3] = e
        this.streetsList.forEach(item => {
          if (item.code === e) {
            this.addressText[3] = item.name
          }
        })
        this.empty(3, true)
      } else {
        this.empty(3, false)
      }
    },

    // 村change
    villageChange(e) {
      if (e) {
        if (this.isShowFn(6)) {
          this.getZuData(e)
        }
        this.addressCode[4] = e
        this.villageList.forEach(item => {
          if (item.code === e) {
            this.addressText[4] = item.name
          }
        })
        this.empty(4, true)
      } else {
        this.empty(4, false)
      }
    },
    // 组change
    zuChange(e) {
      if (e) {
        this.addressCode[5] = e
        this.zuList.forEach(item => {
          if (item.code === e) {
            this.addressText[5] = item.name
          }
        })
        this.empty(5, true)
      } else {
        this.empty(5, false)
      }
    },
    // 查询村（专委会）
    async getVillage(e, key) {
      await villagesPage({ page: 0, size: 1000, pcode: e, sort: 'code' }).then(res => {
        if (res.status === 200) {
          this[key] = res.data.content
        }
      })
    },
    // 查询组
    async getZuData(e) {
      await zuPage({ page: 0, size: 1000, pcode: e, sort: 'code' }).then(res => {
        if (res.status === 200) {
          this.zuList = res.data.content
        }
      })
    },

    // 清空
    empty(n, bol) {
      if (bol) {
        if (n < this.addressSelectPage.showNumber - 1) {
          this.keyList.forEach((item, index) => {
            if (index > n) {
              this.addresObj[this.keyList[index]] = ''
            }
          })
          this.addressCode.splice(n + 1)
          this.addressText.splice(n + 1)
        }
      } else {
        this.keyList.forEach((item, index) => {
          if (index > n) {
            this.addresObj[this.keyList[index]] = ''
          }
        })
        this.dataArrList.forEach((item, index) => {
          if (index > n) {
            this[this.dataArrList[index]] = []
          }
        })
        this.addressCode.splice(n)
        this.addressText.splice(n)
      }
      this.$emit('getAddressData', { code: this.addressCode, text: this.addressText })
    },
    // 禁用规则
    idDisabled(n) {
      if (this.addressSelectPage.isDisabled) {
        if (n <= this.addressSelectPage.disabledNumber) {
          return true
        } else {
          return false
        }
      }
    },
    // 显示规则
    isShowFn(n) {
      let number = this.addressSelectPage.showNumber ? this.addressSelectPage.showNumber : 4
      if (n <= number) {
        return true
      } else {
        return false
      }
    },
    // 尺寸大小规则
    sizeRule() {
      return this.addressSelectPage.size || ''
    },
    async open() {
      this.addresObj = {
        provinces: '',
        cities: '',
        areas: '',
        streets: '',
        village: '',
        zu: ''
      }
      await this.getVillage(0, 'provincesList')
      if (this.addressSelectPage.isSelection) {
        this.addressCode = this.addressSelectPage.code
        // 获取下拉框数据
        await this.getSelectData(this.addressCode)
        // 获取选中name
        let arr = [];
        if (this.addressCode[0]) {//省
          for (let i = 0; i < this.provincesList.length; i++) {
            if (this.provincesList[i].code === this.addressCode[0]) {
              arr.push(this.provincesList[i].name)
            }
          }
        }
        if (this.addressCode[1]) {//市
          let list = this.citiesList
          for (let i = 0; i < list.length; i++) {
            if (list[i].code === this.addressCode[1]) {
              arr.push(list[i].name)
            }
          }
        }
        if (this.addressCode[2]) {//县
          let list = this.areasList
          for (let i = 0; i < list.length; i++) {
            if (list[i].code === this.addressCode[2]) {
              arr.push(list[i].name)
            }
          }
        }
        if (this.addressCode[3]) {//乡镇
          let list = this.streetsList
          for (let i = 0; i < list.length; i++) {
            if (list[i].code === this.addressCode[3]) {
              arr.push(list[i].name)
            }
          }
        }
        if (this.addressCode[4]) {//村（街道）
          let list = this.villageList
          for (let i = 0; i < list.length; i++) {
            if (list[i].code === this.addressCode[4]) {
              arr.push(list[i].name)
            }
          }
        }
        if (this.addressCode[5]) {//组
          let list = this.zuList
          for (let i = 0; i < list.length; i++) {
            if (list[i].code === this.addressCode[5]) {
              arr.push(list[i].name)
            }
          }
        }
        this.addressText = arr
        for (let i = 0; i < this.keyList.length; i++) {
          if (i <= this.addressCode.length) {
            this.addresObj[this.keyList[i]] = this.addressCode[i]
          } else {
            this.addresObj[this.keyList[i]] = ''
          }
        }
        this.$emit('getAddressData', { code: this.addressCode, text: this.addressText })
      }
    },
    // 编辑时获取下拉框数据
    async getSelectData(arr) {
      this.citiesList = []
      this.areasList = []
      this.streetsList = []
      this.villageList = []
      this.zuList = []
      for (let i = 0; i < arr.length; i++) {
        switch (i) {
          case 0:
            // this.citiesList = this.$common.getcities(arr[i])
            if (this.isShowFn(2)) {
              await this.getVillage(arr[i], 'citiesList')
            }
            break
          case 1:
            // this.areasList = this.$common.getareas(arr[i])
            if (this.isShowFn(3)) {
              await this.getVillage(arr[i], 'areasList')
            }
            break
          case 2:
            // this.streetsList = this.$common.getstreets(arr[i])
            if (this.isShowFn(4)) {
              await this.getVillage(arr[i], 'streetsList')
            }
            break
          case 3:
            if (this.isShowFn(5)) {
              await this.getVillage(arr[i], 'villageList')
            }
            break
          case 4:
            if (this.isShowFn(6)) {
              await this.getZuData(arr[i])
            }
            break
          default:
        }
      }
    }

  }
}
// 此组件使用说明
//  <address-selection
//       ref="addressselection"
//       v-model:addressSelectPage="addressSelectPage"
//       @getAddressData="getAddressData"
//     ></address-selection>

// addressSelectPage: {
//   text: ['河南省', '周口市'],
//   code: ['41', '4116'],
//   isSelection: true, // 是否反选
//   isDisabled: true, // 是否禁用
//   disabledNumber: 0, // 禁用数量当isDisabled为true时生效
//   showNumber: 4, // 显示下拉框数量
//   size: 'small'// 尺寸大小
// }
</script>
<style lang="scss"></style>
